/* istanbul ignore file */

import { styled } from '@mui/material/styles';

import { rem } from '../../theme';
interface StyledFloatingButtonProperties {
    $isVisible: boolean;
}

export const StyledFloatingButton = styled(
    'div',
)<StyledFloatingButtonProperties>`
    ${({ theme, $isVisible }) => `
    position: sticky;
    bottom: ${theme.tggSpacing(rem(2), 5)};
    z-index: 1;
    display: ${$isVisible ? 'flex' : 'none'};
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: -2rem;

    button.MuiButton-root {
        &:hover {
            background: ${theme.getRebrandingColor(theme.palette.common.blue, theme.palette.tgg.surface.action.backToTop.hover)};
        }

        &:focus,
        &:focus-visible {
            outline: ${theme.tggSpacing(rem(0.25), 0.5)} solid ${theme.getRebrandingColor(theme.palette.common.blue, theme.palette.tgg.border.focus.main)};
            outline-offset: ${theme.tggSpacing(rem(0.25), 0.5)};
        }

        &:active {
            background: ${theme.getRebrandingColor(theme.palette.common.blue, theme.palette.tgg.surface.action.backToTop.pressed)};
        }
    }

        .MuiButton-textPrimary {
            min-height: ${theme.tggSpacing(rem(0), 10)};
            text-transform: ${theme.isRebranding('lowercase', 'none')};
        }
    `}
`;
